/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line

export const GeneralStyles = {
  'general-page': css`
    display: relative;
  `,
  'page-head': css`
    background: #fff;
    min-height: 60px;
    width: 100%;
    padding: 24px;

    .head-title {
      width: 100%;
      overflow: hidden;
      box-sizing: border-box;
    }
    .title-text {
      display: block;
      float: left;
      margin-bottom: 0;
      padding-right: 12px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 600;
      font-size: 20px;
      line-height: 32px;
    }
  `,
  'page-content': css`
    padding: 24px;
    box-sizing: border-box;

    .content-pane+.content-pane {
      margin-top: 18px;
    }
  `,

  'content-pane': css`
    padding: 24px;
    background: #fff;

    overflow-x: scroll;
  `,
  'simple-pane-inner': css`
    display: flex;

    .simple-line-item+.simple-line-item {
      margin-left: 8px;
    }
  `,
}
